import { Component, OnInit, HostListener } from '@angular/core';
import { HudComponent } from '../hud/hud.component';
import { FooterComponent } from '../footer/footer.component';
@Component({
    selector: 'app-about-us',
    templateUrl: './about-us.component.html',
    styleUrls: ['./about-us.component.css'],
    imports: [HudComponent, FooterComponent]
})
export class AboutUsComponent implements OnInit {

  showCharacters = false;

  ngOnInit() {
    if (window.innerWidth > 1660) {
      this.showCharacters = true;
    }
  }

  @HostListener("window:resize", [])
  onResize() {
    const width = window.innerWidth;
    this.showCharacters = width > 1660;
  }
}
